import { useEffect, useState } from "react";
import { Navbar, Nav, Button, NavDropdown, NavItem } from "react-bootstrap";
import SimpleRenovate from "../../../assets/img/SimpleRenovate.svg";
import { useLocation, useNavigate } from "react-router-dom";
import downIcon from "../../../assets/img/down icon header.svg";
import logout from "../../../assets/img/logout mssg noti.svg";
import userIcon from "../../../assets/img/profileIcon.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AppDownloadModal from "../AppDownloadModal/AppDownloadModal";
import { OPEN_APP_DOWNLOAD_MODAL_EVENT } from "../../../Utils/appDownloadConfig";

const Header = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const [showImg, setShowImg] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showAppDownloadModal, setShowAppDownloadModal] = useState(false);

  // Track which dropdown is open
  const [openDropdown, setOpenDropdown] = useState(null);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const getLastSegmentUrl = () => {
    const pathSegments = location.pathname.split("/");
    return pathSegments[pathSegments.length - 1];
  };

  const lastSegment = getLastSegmentUrl();
  const [lastSegmentUrl, setLastSegmentUrl] = useState(lastSegment);

  const isDropdownActive = (paths) => {
    return paths.some((path) => location.pathname.includes(path));
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openAppDownloadModal = () => {
    setShowAppDownloadModal(true);
  };

  useEffect(() => {
    const handleOpenAppDownloadModal = () => {
      setShowAppDownloadModal(true);
    };

    window.addEventListener(
      OPEN_APP_DOWNLOAD_MODAL_EVENT,
      handleOpenAppDownloadModal,
    );
    return () => {
      window.removeEventListener(
        OPEN_APP_DOWNLOAD_MODAL_EVENT,
        handleOpenAppDownloadModal,
      );
    };
  }, []);

  const getHeaderAvatar = () => {
    try {
      if (localStorage.getItem("clientData")) {
        const client = JSON.parse(localStorage.getItem("clientData"));
        const image = client?.profileImage;
        if (image && String(image).trim() !== "") return image;
        return userIcon;
      }
      if (localStorage.getItem("professionalData")) {
        const pro = JSON.parse(localStorage.getItem("professionalData"));
        const image = pro?.profileImage || pro?.companyLogo;
        if (image && String(image).trim() !== "") return image;
        return userIcon;
      }
      return userIcon;
    } catch {
      return userIcon;
    }
  };

  const isActiveLink = (path) =>
    location.pathname === path ? "activ-nav" : "nav-link-client";

  // Active state checks for each dropdown
  const isProfessionalsActive =
    openDropdown === "professionals" ||
    location.pathname.includes("/professional") ||
    location.pathname.includes("/select-role");

  const isClientsActive =
    openDropdown === "clients" ||
    location.pathname.includes("/client-faqs") ||
    location.pathname.includes("/select-role");

  const isHowItWorksActive =
    openDropdown === "howitworks" ||
    location.pathname.includes("how-it-works") ||
    location.pathname.includes("how-we-vet-professionals");

  const isServicesActive =
    openDropdown === "services" || location.pathname.includes("/service");

  const isResourcesActive =
    openDropdown === "resources" ||
    location.pathname.includes("/about-us") ||
    location.pathname.includes("/blogs") ||
    location.pathname.includes("/contacts-us");

  return (
    <>
    <Navbar
      expand="lg"
      bg="white"
      className="nav-bar-width py-2 py-lg-3 navbar navbar_common navbar-expand-lg navbar-light bg-white"
    >
      <div className="custom_container header-custom-container">
        <div className="nav-width nav_width_lg">
          <div className="header-mobile-row">
            <div className="img_toggle_btn">
              <p
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (
                    !localStorage.getItem("clientData") &&
                    !localStorage.getItem("professionalData") &&
                    lastSegmentUrl !== "signup" &&
                    lastSegmentUrl !== "signup-one"
                  ) {
                    window.location.href = "/";
                  }
                }}
                className="me-0 mb-0"
              >
                <img
                  src={SimpleRenovate}
                  alt="Simple Renovate"
                  className="navbar-logo"
                />
              </p>
            </div>

            {!localStorage.getItem("clientData") &&
              !localStorage.getItem("professionalData") ? (
              <div className="flex_btn_login_signup">
                <Button
                  className="download_now_btn_header download_now_btn_header--mobile"
                  onClick={openAppDownloadModal}
                >
                  Download
                </Button>
                <Button
                  className="login-btn-navbar login_btn_header"
                  onClick={() => {
                    handleViewDetails();
                    navigation("/select-role");
                  }}
                >
                  Log in
                </Button>
                <Button
                  className="signup_btn_header"
                  onClick={() => {
                    handleViewDetails();
                    navigation("/select-role");
                  }}
                >
                  Sign up
                </Button>
              </div>
            ) : (
              <div
                className="profile-dropdown-wrapper d-block d-lg-none header-mobile-profile"
                style={{
                  position: "relative",
                  zIndex: 1050,
                }}
              >
                <div
                  className="profile-icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <img
                    src={
                      localStorage.getItem("clientData")
                        ? JSON.parse(localStorage.getItem("clientData"))
                          .profileImage !== ""
                          ? JSON.parse(localStorage.getItem("clientData"))
                            .profileImage
                          : userIcon
                        : JSON.parse(localStorage.getItem("professionalData"))
                          .companyLogo !== ""
                          ? JSON.parse(localStorage.getItem("professionalData"))
                            .companyLogo
                          : userIcon
                    }
                    alt="user"
                    width={32}
                    height={32}
                    className="user-profile"
                    style={{
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {showDropdown && (
                  <div className="dropdown-menu show p-0 dropdown-menu-logout">
                    <div
                      className="dropdown-item"
                      style={{
                        padding: "10px 16px",
                        cursor: "pointer",
                        color: "#333",
                        transition: "background-color 0.2s",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#f5f5f5")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                      onClick={() => {
                        localStorage.clear();
                        setShowDropdown(false);
                        navigation("/");
                        window.location.reload();
                      }}
                    >
                      <img src={logout} alt="logout" className="me-2" />
                      Logout
                    </div>
                  </div>
                )}
              </div>
            )}

            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="mobile-menu-toggle"
              onClick={() => setShowImg(!showImg)}
            />
          </div>

          {/* Navbar Collapse for mobile */}
          <Navbar.Collapse
            id="basic-navbar-nav"
            className={`d-lg-flex ${showImg ? "d-flex" : "d-none"}`}
          >
            <Nav className="gap-2 gap-lg-1 navbar_links navbar_links_common height_navbar">
              {/* Professionals Dropdown */}
              <NavDropdown
                className={`nav-link-client-show ${isProfessionalsActive ? "activ-nav" : "nav-link-client"
                  }`}
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "professionals" : null)
                }
                title={
                  <>
                    <span
                      style={{
                        color: isProfessionalsActive ? "#cc4645" : "inherit",
                      }}
                    >
                      Professionals
                    </span>
                    <ExpandMoreIcon
                      className="ms-1"
                      style={{
                        color: isProfessionalsActive ? "#cc4645" : "inherit",
                      }}
                    />
                  </>
                }
                href="/select-role"
                id="find-jobs-dropdown"
              >
                <NavDropdown.Item
                  // href="/select-role"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                    navigation("/professional/login", { state: { clickBy: "Professional" } });
                  }}
                >
                  Bid on Jobs
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/professional-faqs"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  className="mb-2 mb-lg-0"
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                  }}
                >
                  FAQs
                </NavDropdown.Item>
              </NavDropdown>

              {/* Clients Dropdown */}
              <NavDropdown
                className={`nav-link-client-show ${isClientsActive ? "activ-nav" : "nav-link-client"
                  }`}
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "clients" : null)
                }
                title={
                  <>
                    <span
                      style={{
                        color: isClientsActive ? "#cc4645" : "inherit",
                      }}
                    >
                      Clients
                    </span>
                    <ExpandMoreIcon
                      className="ms-1"
                      style={{
                        color: isClientsActive ? "#cc4645" : "inherit",
                      }}
                    />
                  </>
                }
                href="/select-role"
                id="find-jobs-dropdown"
              >
                <NavDropdown.Item
                  // href="/select-role"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                    navigation("/client/login", { state: { clickBy: "Client" } });
                  }}
                >
                  Get Bids
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/client-faqs"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  className="mb-2 mb-lg-0"
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                  }}
                >
                  FAQs
                </NavDropdown.Item>
              </NavDropdown>

              {/* How it works Dropdown */}
              <NavDropdown
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "howitworks" : null)
                }
                title={
                  <>
                    <span
                      style={{
                        color: isHowItWorksActive ? "#cc4645" : "inherit",
                      }}
                    >
                      How it works
                    </span>
                    <ExpandMoreIcon
                      className="ms-1"
                      style={{
                        color: isHowItWorksActive ? "#cc4645" : "inherit",
                      }}
                    />
                  </>
                }
                className={`nav-link-client-show ${isHowItWorksActive ? "activ-nav" : "nav-link-client"
                  }`}
                id="how-it-works-dropdown"
              >
                <NavDropdown.Item
                  href="/how-it-works"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                  }}
                >
                  How SimpleRenovate Works
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="/how-we-vet-professionals"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  className="mb-2 mb-lg-0"
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                  }}
                >
                  How We Vet Professionals
                </NavDropdown.Item>
              </NavDropdown>

              {/* Pricing Link */}
              <Nav.Link
                href="/pricing"
                onClick={() => {
                  handleViewDetails();
                }}
                className={isActiveLink("/pricing")}
                style={{
                  fontWeight: "400",
                }}
              >
                Pricing
              </Nav.Link>

              {/* Services Dropdown */}
              <NavDropdown
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "services" : null)
                }
                onClick={() => {
                  handleViewDetails();
                }}
                title={
                  <>
                    <span
                      style={{
                        color: isServicesActive ? "#cc4645" : "inherit",
                      }}
                    >
                      Services
                    </span>
                    <ExpandMoreIcon
                      className="ms-1"
                      style={{
                        color: isServicesActive ? "#cc4645" : "inherit",
                      }}
                    />
                  </>
                }
                className={isServicesActive ? "activ-nav" : "nav-link-client"}
                href="/service"
                id="find-jobs-dropdown"
              >
                {/* Service Items */}

                <NavDropdown.Item
                  href="/service/all-services"
                  onClick={() => {
                    handleViewDetails();
                  }}
                  style={{ color: "#000", fontSize: "14px" }}
                >
                  All Services
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="/service/floor-coverings"
                  onClick={() => {
                    handleViewDetails();
                  }}
                  style={{ color: "#000", fontSize: "14px" }}
                >
                  Floor Coverings
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/service/artificial-grass"
                  onClick={() => {
                    handleViewDetails();
                  }}
                  style={{ color: "#000", fontSize: "14px" }}
                >
                  Artificial Grass
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/service/garage-door"
                  onClick={() => {
                    handleViewDetails();
                  }}
                 style={{ color: "#000", fontSize: "14px" }}
                >
                  Garage Door
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="/service/bath"
                  onClick={() => {
                    handleViewDetails();
                  }}
                  style={{ color: "#000", fontSize: "14px" }}
                >
                  Bath
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/service/kitchen"
                  onClick={() => {
                    handleViewDetails();
                  }}
                  style={{ color: "#000", fontSize: "14px" }}
                >
                  Kitchen
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/service/interior-paint"
                  onClick={() => {
                    handleViewDetails();
                  }}
                  style={{ color: "#000", fontSize: "14px" }}
                >
                  Interior Paint
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/service/doors"
                  onClick={() => {
                    handleViewDetails();
                  }}
                   style={{ color: "#000", fontSize: "14px" }}
                  className="mb-2 mb-lg-0"
                >
                  Doors
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="/service/windows"
                  onClick={() => {
                    handleViewDetails();
                  }}
                  style={{ color: "#000", fontSize: "14px" }}
                  className="mb-2 mb-lg-0"
                >
                  Windows
                </NavDropdown.Item>
              </NavDropdown>

              {/* Resources Dropdown */}
              <NavDropdown
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "resources" : null)
                }
                title={
                  <>
                    <span
                      style={{
                        color: isResourcesActive ? "#cc4645" : "inherit",
                      }}
                    >
                      Resources
                    </span>
                    <ExpandMoreIcon
                      className="ms-1"
                      style={{
                        color: isResourcesActive ? "#cc4645" : "inherit",
                      }}
                    />
                  </>
                }
                className={`nav-link-client-show ${isResourcesActive ? "activ-nav" : "nav-link-client"
                  }`}
                href="#"
                id="find-jobs-dropdown"
              >
                <NavDropdown.Item
                  href="/about-us"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                  }}
                >
                  About Us
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/blogs"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  className="mb-lg-0"
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                  }}
                >
                  Blogs
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/contacts-us"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                  }}
                  className="mb-2 mb-lg-0"
                  onClick={() => {
                    handleViewDetails();
                    setShowImg(!showImg);
                  }}
                >
                  Contact Us
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>

          {!localStorage.getItem("clientData") &&
            !localStorage.getItem("professionalData") ? (
            <div className="flex_btn_login_signup_lg">
              <Button
                className="download_now_btn_header"
                onClick={openAppDownloadModal}
              >
                Download App
              </Button>
              <Button
                className="login-btn-navbar login_btn_header"
                onClick={() => {
                  handleViewDetails();
                  navigation("/select-role");
                }}
              >
                Log in
              </Button>
              <Button
                className="signup_btn_header"
                onClick={() => {
                  handleViewDetails();
                  navigation("/select-role");
                }}
              >
                Sign up
              </Button>
            </div>
          ) : (
            <div
              className="profile-dropdown-wrapper d-none d-lg-block"
              style={{
                position: "relative",
                zIndex: 1050,
              }}
            >
              <div
                className="profile-icon"
                style={{ cursor: "pointer" }}
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <img
                  src={getHeaderAvatar()}
                  alt="user"
                  width={32}
                  height={32}
                  className="user-profile"
                  style={{
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.currentTarget.src = userIcon;
                  }}
                />
              </div>

              {showDropdown && (
                <div
                  className="dropdown-menu show p-0 dropdown-menu-logout"
                  style={{}}
                >
                  <div
                    className="dropdown-item"
                    style={{
                      padding: "10px 16px",
                      cursor: "pointer",
                      color: "#333",
                      transition: "background-color 0.2s",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.backgroundColor = "#f5f5f5")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.backgroundColor = "transparent")
                    }
                    onClick={() => {
                      localStorage.clear();
                      setShowDropdown(false);
                      navigation("/");
                      window.location.reload(); // Force refresh to update UI
                    }}
                  >
                    <img src={logout} alt="logout" className="me-2" />
                    Logout
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Navbar>
    <AppDownloadModal
      show={showAppDownloadModal}
      onHide={() => setShowAppDownloadModal(false)}
    />
    </>
  );
};

export default Header;
